<template>
    <li>
        <i :class="icon"></i>
        <ul>
            <li v-for="link in links">
                <a :href="link.href">{{link.name}}</a>
            </li>
        </ul>
    </li>
</template>

<script>

    export default {
        props: ['links', 'icon']
    }

</script>
